import { IntlShape, defineMessages } from 'react-intl'
import * as yup from 'yup'

import { IUploadCsvFormValues } from 'features/OperationalCosts/types'

const urlMessages = defineMessages({
  required: {
    id: 'operationalCosts.form.url.required',
    defaultMessage: 'Link is required'
  },
  format: {
    id: 'operationalCosts.form.url.format',
    defaultMessage: 'Invalid link format'
  }
})

export const schema = (intl: IntlShape): yup.SchemaOf<IUploadCsvFormValues> => {
  return yup.object().shape({
    url: yup.string().url(intl.formatMessage(urlMessages.format)).required(intl.formatMessage(urlMessages.required)),
    businessClient: yup
      .object()
      .shape({
        id: yup.string(),
        name: yup.string()
      })
      .nullable(),
    businessSite: yup
      .object()
      .shape({
        id: yup.string(),
        name: yup.string()
      })
      .nullable()
  })
}
